import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { BackButtonHeader } from "@/components/vroom/back-button-header";

export const Route = createFileRoute("/_authed/work/new/type")({
  validateSearch: (s: Record<string, unknown>): { date: string } => ({
    date: typeof s.date === "string" ? s.date : new Date().toISOString().slice(0, 10),
  }),
  component: TypeChooser,
});

function TypeChooser() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { date } = Route.useSearch();

  return (
    <div className="px-4 py-6 space-y-4">
      <BackButtonHeader title={t("work.new.type.title")} onBack={() => history.back()} />
      <Button
        className="w-full"
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onClick={() =>
          void navigate({ to: "/work/new/work" as any, search: { date, type: "werk" } as any })
        }
      >
        {t("work.type.werk")}
      </Button>
      <Button
        className="w-full"
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onClick={() =>
          void navigate({ to: "/work/new/work" as any, search: { date, type: "onderhoud" } as any })
        }
      >
        {t("work.type.onderhoud")}
      </Button>
      <Button
        className="w-full"
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onClick={() =>
          void navigate({
            to: "/work/new/no-work" as any,
            search: { date, type: "geenwerk" } as any,
          })
        }
      >
        {t("work.type.geenwerk")}
      </Button>
      <Button
        className="w-full"
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onClick={() =>
          void navigate({ to: "/work/new/no-work" as any, search: { date, type: "verlof" } as any })
        }
      >
        {t("work.type.verlof")}
      </Button>
      <Button
        className="w-full"
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onClick={() =>
          void navigate({ to: "/work/new/no-work" as any, search: { date, type: "ziek" } as any })
        }
      >
        {t("work.type.ziek")}
      </Button>
    </div>
  );
}
